import React, { useState } from "react";
import { compose, graphql } from "react-apollo";
import Table from "components/Table/Table";
import { withQuery } from "containers/withQuery";
import PencilButton from "components/ActionButtons/PencilButton";
import DeleteButton from "components/ActionButtons/DeleteButton";
import AlertModal from "components/AlertModal/AlertModal";
import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { SENSORS_QUERY } from "../generalRegisterQueries";
import { DELETE_SENSOR_MUTATION } from "../generalRegisterMutations";
import SensorEdit from "./SensorEdit";
import { sensorMaterialTypes } from "../enumTypes";

const headers = [
  {
    label: "Id", key: "id",
  },
  {
    label: "Nome", key: "name",
  },
  {
    label: "Unidade", key: "unit",
  },
  {
    label: "Tipo de Material", key: "materialType",
  },
  {
    label: "", key: "action",
  },
  {
    label: "", key: "delete",
  },
];

const SensorsTable = ({
  deleteSensor,
  snackbarContext,
  sensors,
}) => {
  const [editId, setEditId] = useState(null);

  const openEdit = (id) => {
    setEditId(id);
  };

  const closeEdit = () => {
    setEditId(null);
  };

  const handleDeleteSensor = async (id) => {
    try {
      await deleteSensor({
        variables: { id },
        refetchQueries: [{ query: SENSORS_QUERY }],
      });

      snackbarContext.setNotificationTimeOut(
        Color.success,
        "Sensor deletado."
      );
    } catch (error) {
      snackbarContext.setNotificationTimeOut(
        Color.danger,
        translateErrorMessage(error)
      );
    };
  };

  const handleDeleteModal = (id) => {
    AlertModal.fire({
      title: "Deletar Sensor",
      html: "Deseja deletar o sensor selecionado?",
      type: "error",
      showCancelButton: true,
      confirmButtonColor: "#1D84C6",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Voltar",
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        handleDeleteSensor(id);
      }
    });
  };

  const buildTableItems = () => (
    [...sensors]
      .sort((a, b) => a.id - b.id)
      .map(sensor => ({
        ...sensor,
        materialType: sensorMaterialTypes[sensor.materialType],
        action: (
          <PencilButton
            onPencilEditClick={() => openEdit(sensor.id)}
          />
        ),
        delete: (
          <DeleteButton
            onClick={() => handleDeleteModal(sensor.id)}
          />
        ),
      }))
  );

  return (
    <React.Fragment>
      <Table
        headers={headers}
        matchHeaders
        items={buildTableItems()}
      />

      {editId && (
        <SensorEdit
          id={editId}
          onFinishEdit={closeEdit}
        />
      )}
    </React.Fragment>
  );
};

export default compose(
  withQuery({ query: SENSORS_QUERY }),
  graphql(DELETE_SENSOR_MUTATION, { name: "deleteSensor", }),
  withSnackbarConsumer,
)(SensorsTable);
